import React from 'react';
import styled from 'styled-components';
import Colours from './shared/styled/Colours';
import BlobLoader from './shared/BlobLoader';

interface ISplashLayout {
  isBrandLoaded: boolean;
}

const Title = styled.h1`
  margin-top: 40px;
`;

const Container = styled.div<ISplashLayout>`
  background-color: ${Colours.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 1;
  visibility: visible;
  z-index: 1000;
  transition: opacity ease 400ms 0s, visibility linear 0s 400ms;

  ${({ isBrandLoaded }) =>
    isBrandLoaded &&
    `
    opacity: 0;
    visibility: hidden;
  `}

  ${Title} {
    opacity: 0;
  }

  ${Title} {
    animation-name: message-in;
    animation-duration: 400ms;
    animation-timing-function: ease-out;
    animation-iteration-count: infinte;
    animation-delay: 1s;
    animation-fill-mode: forwards;
    margin-bottom: 4px;
    margin-top: 40px;
  }

  @keyframes message-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes colour-in {
    20% {
      color: ${Colours.black};
    }
    100% {
      color: ${Colours.primary};
    }
  }
`;

const SplashLayout = ({ isBrandLoaded }: ISplashLayout) => (
  <Container isBrandLoaded={isBrandLoaded}>
    <BlobLoader />
    <Title className="text32--emphasis">Loading returns</Title>
  </Container>
);

export default SplashLayout;
